module.exports = __webpack_public_path__ + "img/tropy.dc34039d.svg";